/**
 * Homepage hero: static copy panel + frozen slideshow (static banners).
 * Laptop and phone both use a single banner image (no rotation).
 * Revert: remove from script-tags.liquid + related CSS.
 */
(function () {
  function findSection() {
    return document.querySelector('.tmn-home-hero');
  }

  function findSource(section) {
    return (
      section.querySelector('.swiper-slide[data-slide="0"] .m-slide__content') ||
      section.querySelector('.swiper-wrapper .m-slide__content') ||
      section.querySelector('.m-slide__content')
    );
  }

  function getSlider(section) {
    var el = section && section.querySelector('m-slideshow');
    return el && el.slider ? el.slider : null;
  }

  function freezeSlider(section) {
    var slider = getSlider(section || findSection());
    if (!slider) return;

    if (slider.autoplay && slider.autoplay.stop) slider.autoplay.stop();
    slider.allowTouchMove = false;
    if (typeof slider.slideToLoop === 'function') {
      slider.slideToLoop(0, 0);
    } else if (typeof slider.slideTo === 'function') {
      slider.slideTo(0, 0);
    }
  }

  function init() {
    var section = findSection();
    if (!section || section.dataset.tmnStaticCopy === '1') return;

    var source = findSource(section);
    if (!source || !source.innerHTML.trim()) return;

    var host =
      section.querySelector('.container-full, .container-fluid, .container') || section;

    var layer = document.createElement('div');
    layer.className = 'tmn-hero-static-layer';

    var clone = source.cloneNode(true);
    clone.className = 'm-slide__content tmn-hero-static-copy';
    clone.removeAttribute('data-cascade');
    clone.classList.remove('m-scroll-trigger', 'animate--fade-in-up', 'animate--fade-in');

    layer.appendChild(clone);

    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }
    host.appendChild(layer);

    section.dataset.tmnStaticCopy = '1';
    section.classList.add('tmn-hero-static-copy-on');
    freezeSlider(section);

    // Keep a single H1: demote titles inside hidden slide clones
    section.querySelectorAll('.m-slide__content:not(.tmn-hero-static-copy) h1.m-slide__title').forEach(function (el) {
      var replacement = document.createElement('h2');
      replacement.className = el.className;
      replacement.innerHTML = el.innerHTML;
      el.replaceWith(replacement);
    });
  }

  function tryInit(attempt) {
    init();
    var section = findSection();
    if (section && section.dataset.tmnStaticCopy === '1') {
      freezeSlider(section);
      return;
    }
    if (attempt < 10) {
      setTimeout(function () {
        tryInit(attempt + 1);
      }, 150 * (attempt + 1));
    }
  }

  function resetAndInit() {
    var section = findSection();
    if (!section) return;
    section.dataset.tmnStaticCopy = '';
    section.classList.remove('tmn-hero-static-copy-on');
    var old = section.querySelector('.tmn-hero-static-layer');
    if (old) old.remove();
    tryInit(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      tryInit(0);
    });
  } else {
    tryInit(0);
  }

  window.addEventListener('load', function () {
    var section = findSection();
    if (section && !section.classList.contains('tmn-hero-static-copy-on')) {
      tryInit(0);
    }
    freezeSlider(section);
  });

  document.addEventListener('shopify:section:load', resetAndInit);
})();
